/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  CreateMcpServerForm,
  CreateMcpServerForm$Outbound,
  CreateMcpServerForm$outboundSchema,
} from "../components/createmcpserverform.js";

export type CreateMcpServerSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type CreateMcpServerSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type CreateMcpServerSecurity = {
  option1?: CreateMcpServerSecurityOption1 | undefined;
  option2?: CreateMcpServerSecurityOption2 | undefined;
};

export type CreateMcpServerRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  createMcpServerForm: CreateMcpServerForm;
};

/** @internal */
export type CreateMcpServerSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const CreateMcpServerSecurityOption1$outboundSchema: z.ZodMiniType<
  CreateMcpServerSecurityOption1$Outbound,
  CreateMcpServerSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function createMcpServerSecurityOption1ToJSON(
  createMcpServerSecurityOption1: CreateMcpServerSecurityOption1,
): string {
  return JSON.stringify(
    CreateMcpServerSecurityOption1$outboundSchema.parse(
      createMcpServerSecurityOption1,
    ),
  );
}

/** @internal */
export type CreateMcpServerSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const CreateMcpServerSecurityOption2$outboundSchema: z.ZodMiniType<
  CreateMcpServerSecurityOption2$Outbound,
  CreateMcpServerSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function createMcpServerSecurityOption2ToJSON(
  createMcpServerSecurityOption2: CreateMcpServerSecurityOption2,
): string {
  return JSON.stringify(
    CreateMcpServerSecurityOption2$outboundSchema.parse(
      createMcpServerSecurityOption2,
    ),
  );
}

/** @internal */
export type CreateMcpServerSecurity$Outbound = {
  Option1?: CreateMcpServerSecurityOption1$Outbound | undefined;
  Option2?: CreateMcpServerSecurityOption2$Outbound | undefined;
};

/** @internal */
export const CreateMcpServerSecurity$outboundSchema: z.ZodMiniType<
  CreateMcpServerSecurity$Outbound,
  CreateMcpServerSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => CreateMcpServerSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => CreateMcpServerSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function createMcpServerSecurityToJSON(
  createMcpServerSecurity: CreateMcpServerSecurity,
): string {
  return JSON.stringify(
    CreateMcpServerSecurity$outboundSchema.parse(createMcpServerSecurity),
  );
}

/** @internal */
export type CreateMcpServerRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  CreateMcpServerForm: CreateMcpServerForm$Outbound;
};

/** @internal */
export const CreateMcpServerRequest$outboundSchema: z.ZodMiniType<
  CreateMcpServerRequest$Outbound,
  CreateMcpServerRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    createMcpServerForm: CreateMcpServerForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      createMcpServerForm: "CreateMcpServerForm",
    });
  }),
);

export function createMcpServerRequestToJSON(
  createMcpServerRequest: CreateMcpServerRequest,
): string {
  return JSON.stringify(
    CreateMcpServerRequest$outboundSchema.parse(createMcpServerRequest),
  );
}
